module.exports = __webpack_public_path__ + "static/media/list-view.8b218d30.svg";